import Upgrade from '../classes/upgrade';

const decProdTime = 'decreaseProductionTime',
    incEarnings   = 'increaseEarnings',
    showEarnings  = 'showEarningsPerSecond',
    _upgrades     = [
        //region LemonadeStands
        new Upgrade({
            name:   'Sharper knives',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Fancy umbrellas',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Lemon squeezer 5000',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Straws',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Ice cubes',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Juicier lemons',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Fancy umbrellas',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Billboard advertising',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Help from the neighbour\'s kids',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      1,
            shop:        'LemonadeStand',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Addition of caffeine',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Crystal lemonade',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Add tequila',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Free refills',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Stevia',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Vending machines',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'More flavors',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'BOGOF',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Light lemonade',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Forged health study',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Self-cutting lemons',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        new Upgrade({
            name:   'Bottling plant',
            shopID: 1,
            shop:   'LemonadeStand'
        }),
        //endregion
        //region PaperDelivery
        new Upgrade({
            name:   'Shoulder bag',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Additional brochures',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Bike',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Bike trailer',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Raincoat',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Newspaper cannons',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Printing press',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Self publishing',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Digital issue',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      2,
            shop:        'PaperDelivery',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'TV programme',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Horoscope',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Editorial department',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Crossword puzzle',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Sports section',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Obituaries',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Feuilleton',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Foreign correspondent',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Economy section',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Nationwide delivery',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Pulitzer Prize',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        new Upgrade({
            name:   'Low orbit newspaper delivery',
            shopID: 2,
            shop:   'PaperDelivery'
        }),
        //endregion
        //region ShoeShop
        new Upgrade({
            name:   'Sell single shoes',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Spring collection',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Shoehorn',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Summer collection',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Winter collection',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Foot X-Ray',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Warehouse',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Colorful shoe laces',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Self-produced leather',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      3,
            shop:        'ShoeShop',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Own brand',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Third world production country',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Child labor',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Blinking shoes',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Inlays',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Platforms',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Shoe shine',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'UKK boots',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Famous designer product line',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Concrete shoes',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Shoe care product line',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        new Upgrade({
            name:   'Self-running shoes',
            shopID: 3,
            shop:   'ShoeShop'
        }),
        //endregion
        //region PizzaDelivery
        new Upgrade({
            name:   'Bike',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Luigi\'s secret sauce recipe',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Pizza cutter',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Peel',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Low-carb',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Native olive oil',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Scooter',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Stone oven',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Dishwasher',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      4,
            shop:        'PizzaDelivery',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Cheap paper pizza boxes',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Printed menus',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Real italian cook',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Car',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Helicopter',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Cheese crust',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Frozen pizza',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'BOGOF',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Cheese analogue',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Instant pizza',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Pizza world champion',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        new Upgrade({
            name:   'Verace Pizza Napoletana',
            shopID: 4,
            shop:   'PizzaDelivery'
        }),
        //endregion
        //region Baker
        new Upgrade({
            name:   'Bigger oven',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Pre-cut bread',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Kneading machine',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Wedding cakes',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Flavor enhancers',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Lunch specials',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Party service',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Sandwiches',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Baking mixture',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      5,
            shop:        'Bakery',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Gluten-free goods',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Bio grade bread',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Baking courses',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Bockwurst with bread',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Coffee shop',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Bakerman is baking bread',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Self-service',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Locally milled flour',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Wholesale bakery',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Pastry chef',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Franchise bakery',
            shopID: 5,
            shop:   'Bakery'
        }),
        new Upgrade({
            name:   'Fettes Brot',
            shopID: 5,
            shop:   'Bakery'
        }),
        //endregion
        //region LampStore
        new Upgrade({
            name:   'Warehouse',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Bigger assortment',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Lamp exhibition',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Electric bulbs',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Own brand',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Lamp exhibition',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Designer lamps',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Antique oil lamps',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Office equipment',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      6,
            shop:        'LampStore',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Gas lights',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Sales representative',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Sell accessories',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Merchant shop',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Smart home',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Solar panels',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Grow lamps',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Bulk order',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Industrial lighting',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Darklights',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Power generating lights',
            shopID: 6,
            shop:   'LampStore'
        }),
        new Upgrade({
            name:   'Superluminal velocity lights',
            shopID: 6,
            shop:   'LampStore'
        }),
        //endregion
        //region SoccerTeam
        new Upgrade({
            name:   'Youth department',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Football ground',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Sporting director',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Move up the league',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Star trainer',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Main sponsor',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Advertising boards',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Fitness coach',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Stadium',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      7,
            shop:        'SoccerTeam',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Medical team',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Doping',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'League winner',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Champions League',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Women\'s team',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Press department',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Intercontinental Cup winner',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'International merchandise',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Talent scouts',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'PR tour through Asia',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Robots team',
            shopID: 7,
            shop:   'SoccerTeam'
        }),
        new Upgrade({
            name:   'Become FIFA president',
            shopID: 7,
            shop:   'SoccerTeam'
        }),

        // movie studio - id 8
        new Upgrade({
            name:   'Electronic ticketing',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Soft drinks',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Short films',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Popcorn',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Ice cups',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Silent movies',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   '3D projector',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Surround sound',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Double features',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      8,
            shop:        'MovieStudio',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Own productions',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Smoking theatre',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Additional length surcharges',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Cuddle seats',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Sneak previews',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Smelly-Vision',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        // new Upgrade({
        //     name:        'Triple features',
        //     shopID:      8,
        //     shop:        'MovieStudio',
        //     bonusType:   incEarnings,
        //     bonusFactor: 2
        // }),
        new Upgrade({
            name:   'Adult movies',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Laser shows',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Working DRM',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Sports live streaming',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        // new Upgrade({
        //     name:        'Film festival',
        //     shopID:      8,
        //     shop:        'MovieStudio',
        //     bonusType:   incEarnings,
        //     bonusFactor: 2
        // }),
        new Upgrade({
            name:   'Concerts live streaming',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        new Upgrade({
            name:   'Anti-privacy campaign',
            shopID: 8,
            shop:   'MovieStudio'
        }),
        //endregion
        //region Airline
        new Upgrade({
            name:   'Supersonic planes',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Business class',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Bigger fleet',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Sexy stewardesses',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'First class',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'New routes',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Tax free shopping',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Tomato juice',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Sexy stewards',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      9,
            shop:        'Airline',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Charter flights',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Miles bonus program',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Air marshals',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Solar planes',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'In-flight entertainment',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'More legroom',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Autopilot',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Package holidays',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Internet access',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Own airport',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Flight to the moon',
            shopID: 9,
            shop:   'Airline'
        }),
        new Upgrade({
            name:   'Crash-proof planes',
            shopID: 9,
            shop:   'Airline'
        }),
        //endregion
        //region Bank
        new Upgrade({
            name:   'ATMs',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Giant vault',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Phone banking',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Transaction fees',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Higher interest',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Safe deposit boxes',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Insurances',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Call center',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Online banking',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      10,
            shop:        'Bank',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Bank stability program',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Colorful flags',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Stock trading',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Credit cards',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Tax saving program',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Bitcoin trading',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Giant novelty cheques',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Investment banking',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Insider trading',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Big bank',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Fort Knox',
            shopID: 10,
            shop:   'Bank'
        }),
        new Upgrade({
            name:   'Money press',
            shopID: 10,
            shop:   'Bank'
        }),
        //endregion
        //region CarManufacturer
        new Upgrade({
            name:   'Assembly lines',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Airbags',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Welding robots',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'ESP',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'ABS',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Limousine',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Convertible',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Family van',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Self-driving cars',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      11,
            shop:        'CarManufacturer',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'SUV',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Bio fuel powered cars',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Amphibious vehicles',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Electric cars',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Luxury brand',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Supersonic car',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Flying car',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Car rental',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Leasing',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Unflattable tires',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Car museum',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        new Upgrade({
            name:   'Racing team',
            shopID: 11,
            shop:   'CarManufacturer'
        }),
        //endregion
        //region DrugRing
        new Upgrade({
            name:   'New dealers',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Homegrown weed',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Bulk pack smuggle condoms',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Goon squad',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'New trending drug',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Drug lab',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Smuggle planes',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Marihuana legalization',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Greenhouse',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:        'UpgradeShowIncomePerSecond',
            shopID:      12,
            shop:        'DrugRing',
            description: 'Shows earnings per second'
        }),
        new Upgrade({
            name:   'Automatic weapons',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Counterfeited drugs',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Smuggle tunnel',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Killer commando',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Bribes',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Get rid of competitor',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Invisibility cloak',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Opium poppy fields',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Speedboat',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Plane',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Netflix series',
            shopID: 12,
            shop:   'DrugRing'
        }),
        new Upgrade({
            name:   'Own country',
            shopID: 12,
            shop:   'DrugRing'
        }),
        //endregion
        //region General
        new Upgrade({
            name:        'Magenta online shop',
            shopID:      0,
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'tx;commerce online shop',
            shopID:      0,
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'StoreWare online shop',
            shopID:      0,
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'JTL-Shop3',
            shopID:      0,
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'JTL-Shop4',
            shopID:      0,
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'JTL-Shop5',
            shopID:      0,
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'JTL-Shop6',
            shopID:      0,
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'JTL-WaWi 0.999948',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'JTL-WaWi 1.0',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'JTL-WaWi 2.0',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Newsletter campaign',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Service partner',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Premium service partner',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'AdWords campaign',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'SEO optimizations',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'SEO agency',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Content agency',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'TOTAL',
            shop:        'all',
            bonusType:   'showTotalEarningsPerSecond',
            description: 'Shows total earnings per second'
        }),
        new Upgrade({
            name:        'Drone shipping',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Google Analytics',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Spam campaign',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Credit screening',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Express delivery',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Local newspaper ads',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Radio ads',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'TV ads',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Trusted Shops certification',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'PayPal',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'PayPal Plus',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'TÜV certification',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Price comparison portal',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Phone book entry',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Store cards',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Social media expert',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Smear campaign',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Tax accountant',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Hostile takeover',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Lobbyist',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Restructuring',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Certified vocational training company',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Own app',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Downsizing of human resources',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Brain trust',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Consulting firm',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Investment strategy',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Initial public offering',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2
        }),
        new Upgrade({
            name:        'Divine proportion',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 1.6180339887498948
        }),
        new Upgrade({
            name:        'Root of all evil',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 1.4142135623
        }),
        new Upgrade({
            name:        '"e"-commerce',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 2.7182818284590452
        }),
        new Upgrade({
            name:        'Tasty pies',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 3.1415926535897932384626433832795
        }),
        new Upgrade({
            name:        'Acceleration!',
            shop:        'all',
            bonusType:   incEarnings,
            bonusFactor: 9.80665
        })
        //endregion
    ],
    upgradesCount = _upgrades.length;
let upgradesByShopID = [];

_upgrades.filter((obj, idx) => {
    // calculate amount of single shops. this will result in an array where the index is the shop id and the value is the amount
    if ('shopID' in obj) {
        if (typeof upgradesByShopID[obj.shopID] === 'undefined') {
            upgradesByShopID[obj.shopID] = [];
        }
        upgradesByShopID[obj.shopID].push(obj);
        obj.id = idx;
        return true;
    }
    obj.id = idx;
    return false;
});
for (let i = 0; i < upgradesCount; ++i) {
    // now that we know the amount of shops per upgrade, we can calculate the costs
    // the later an upgrade is in the list, the more expensive it gets, so the index is used to calculate the costs
    _upgrades[i]
        .setFAClass()
        .setID(`upg-${i}`)
        .setIDX(i + 1)
        .setCosts(_upgrades[i].getCosts(upgradesByShopID[_upgrades[i].shopID]))
        .setDescription(_upgrades[i].generateDescription());
}
upgradesByShopID.forEach(u => {
    u.forEach((up, i) => {
        if (up.shopID > 0) {
            up.bonusType = incEarnings;
            up.bonusFactor = 2;
            if (i === 0 || i === 2 || i === 8) {
                up.bonusType = decProdTime;
            } else if (i === 9) {
                up.bonusType = showEarnings;
            } else if (i === 4 || i === 7 || i === 12 || i === 19) {
                up.bonusFactor = 3;
            } else if (i === 20) {
                up.bonusFactor = 5;
            }
        }
    });
});

// upgradesByShopID.forEach(u => {
//     u.forEach((up, i) => {
//console.log(up.shop, up.bonusType, up.bonusFactor);
// if (up.bonusType === decProdTime) {
//     console.log(up.name);
// }
// if (up.bonusType === showEarnings) {
//         //     console.log('income/s for ' + up.shop, '@idx ', i);
//         // } else if (up.bonusType === decProdTime) {
//         //     console.log('dec time by ' + up.bonusFactor + ' for ' + up.shop, '@idx ', i);
//         // } else if (up.bonusType === incEarnings) {
//         //     console.log('inc income by ' + up.bonusFactor + ' for ' + up.shop, '@idx ', i);
//         // } else {
//         //     console.log('unknown upgrade type: ', up);
//         // }
//         if (up.shop === 'LemonadeStand') {
//             console.log('LS factor:', up.bonusFactor, 'for idx', i);
//         }
//         if (i === 0 || i === 2) {
//             if (up.bonusType !== decProdTime) {
//                 console.error('Wrong update at idx', i, ':', up);
//             }
//             if (i === 0 && up.bonusFactor !== 2) {
//                 console.error('Wrong factor at idx', i, ':', up);
//             }
//             if (i === 2 && up.bonusFactor !== 2) {
//                 console.error('Wrong factor at idx', i, ':', up);
//             }
//         } else if (i === 1 || i === 3) {
//             if (up.bonusType !== incEarnings) {
//                 console.error('Wrong update at idx', i, ':', up);
//             }
//             if (i === 1 && up.bonusFactor !== 2) {
//                 console.error('Wrong factor at idx', i, ':', up);
//             }
//             if (i === 3 && up.bonusFactor !== 3) {
//                 console.error('Wrong factor at idx', i, ':', up);
//             }
//         } else if (i === 9 && up.bonusType !== showEarnings) {
//             console.error('not showEarnings: ', up);
//         }
//     })
// });
_upgrades.sort((a, b) => {
    if (a.costs.lt(b.costs)) {
        return -1;
    }
    return a.costs.gt(b.costs)
        ? 1
        : 0;
});
export default {
    getUpgrades(cb) {
        return cb(_upgrades);
    }
};
